/**
  What is an identity function for? 
  1) Filtering out falsy values from a list
  ```
  const list = ["", null, undefined, 0, NaN, 1, 'a', [], {}]
  const result = list.filter(identity)
  => [1, 'a', [], {}]
  ```
  **WARNING - in JS this will filter out 0 values from a list**
 */
export function identity<T>(arg: T): T {
  return arg;
}
